export var DASHBOARD = 'dashboard';
export var DASHBOARD_LABEL = 'ra.page.dashboard';
